import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import swal from 'sweetalert2';

@Component({
  selector: 'app-issue-alert-grid',
  templateUrl: './issue-alert-grid.component.html',
  styleUrls: ['./issue-alert-grid.component.css']
})
export class IssueAlertGridComponent implements OnInit {
  UserName: any;
  issueList;
  userList;
  hideupdate;
  isSearch: boolean;
  s: Search;
  Ticketcount: any = {};
  buttoncolorclose: string = "warn";
  buttoncoloropen: string = "primary";
  buttoncolornew: string = "warn";


  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.getUsers();
    this.getTicketCount();
    this.getIssueAlert();
  }
  getTicketCount() {

    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetTicketCount()
      .subscribe(
        (data: any) => {
          this.Ticketcount = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  getIssueAlert() {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getIssueAlert()
      .subscribe(
        (data: any) => {
          this.issueList = data;
          for (let i = 0; i < this.issueList.length; i++)
            if (this.issueList[i].roleName == 'Clients') {
              this.hideupdate = 1;
            }
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  //Closed Issues
  Closed() {
    //For button color
    this.buttoncolorclose = "primary";
    this.buttoncoloropen = "warn";
    this.buttoncolornew = "warn";

    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getIssueAlertClosed().subscribe(
      (data: any) => {
        this.issueList = data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      }
    )
  }
  //Open Issues
  Open() {
    //For button color
    this.buttoncolorclose = "warn";
    this.buttoncoloropen = "primary";
    this.buttoncolornew = "warn";

    document.getElementById('loader-spinner').style.display = "block";
    debugger
    this.userService.getIssueAlert().subscribe(
      (data: any) => {
        this.issueList = data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      }
    )
  }

  //New Issues
  New() {
    //For button color
    this.buttoncolorclose = "warn";
    this.buttoncoloropen = "warn";
    this.buttoncolornew = "primary";

    document.getElementById('loader-spinner').style.display = "block";
    debugger
    this.userService.getIssueAlertNew().subscribe(
      (data: any) => {
        this.issueList = data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      }
    )
  }

  getUsers() {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getUsers()
      .subscribe(
        (data: any) => {
          this.userList = data;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  updateViewStatus(IS_Id: any) {
    debugger;
    this.UserName = localStorage.getItem('userName');
    this.userService.updateViewStatus(IS_Id, this.UserName)
      .subscribe(
        (data: any) => {

        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  onSearch(s) {
    debugger;
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.SearchTokens(searchCriteria, searchText)
        .subscribe(
          (data: any) => {
            this.issueList = data;
            for (let i = 0; i < this.issueList.length; i++)
              if (this.issueList[i].roleName == 'Clients') {
                this.hideupdate = 1;
              }
            // this.totalItems = data.TotalItemsCount;
            // this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/issues/issue-alert-grid/issue-alert-grid.component.ts